import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { connectSortBy } from "react-instantsearch-dom";

import { cn } from "utils";

import { getSortItems } from "../sortItems";
import CollapsiblePanel from "./CollapsiblePanel";

const SortByDropdownPanel = ({
  items,
  refine,
  currentRefinement,
  defaultRefinement,
}) => {
  const [collapseTrigger, setCollapseTrigger] = useState(0);
  const activeValue = currentRefinement || defaultRefinement;
  const currentLabel =
    items.find((item) => item.value === activeValue)?.label || "Default";

  const handleSelect = (value) => {
    refine(value);
    setCollapseTrigger((prev) => prev + 1);
  };

  return (
    <CollapsiblePanel
      header={`Sort by: ${currentLabel}`}
      sectionKey="sort-by"
      defaultCollapsed={true}
      collapseTrigger={collapseTrigger}
      chevronPosition="right"
      headerClassName="text-xs font-normal text-slate-700"
      overlay
      excludeFromExpandAll
      className="z-10"
    >
      <ul className="ais-RefinementList-list my-0">
        {items.map((item) => {
          const isSelected = item.value === activeValue;

          return (
            <li
              key={item.value}
              className={cn("ais-RefinementList-item", {
                "ais-RefinementList-item--selected": isSelected,
              })}
            >
              <button
                type="button"
                className={cn(
                  "ais-RefinementList-label w-full cursor-pointer border-0 bg-transparent p-0 text-left",
                  {
                    "font-semibold": isSelected,
                  }
                )}
                onClick={() => handleSelect(item.value)}
              >
                <span className="ais-RefinementList-labelText">
                  {item.label}
                </span>
              </button>
            </li>
          );
        })}
      </ul>
    </CollapsiblePanel>
  );
};

SortByDropdownPanel.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string.isRequired,
      isRefined: PropTypes.bool,
    })
  ).isRequired,
  refine: PropTypes.func.isRequired,
  currentRefinement: PropTypes.string,
  defaultRefinement: PropTypes.string,
};

const ConnectedSortByDropdownPanel = connectSortBy(SortByDropdownPanel);

const SearchSortByDropdown = ({ indexName }) => {
  const items = useMemo(() => getSortItems(indexName), [indexName]);

  if (!indexName) {
    return null;
  }

  return (
    <div id="filter-group-sort-by" className="filter-sort-by">
      <ConnectedSortByDropdownPanel
        defaultRefinement={indexName}
        items={items}
      />
    </div>
  );
};

SearchSortByDropdown.propTypes = {
  indexName: PropTypes.string,
};

export default SearchSortByDropdown;
